module.exports = __webpack_public_path__ + "459e9c04303b798e472e3b7ae3e1ee0f.svg";